import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';

import {Hub} from '../types/hub';
import {HubService} from '../services/hub.service';
import {AppComponent} from '../app.component';
import {Installation} from '../types/installation';

@Component({
  selector: 'installations',
  template: `<stock-sub-menu></stock-sub-menu>
<div *ngFor="let category of categories()">
    <installation-category
        [category]="category"
        [installations]="installations"
        [expanded]="!!expanded[category]"
        [count]="+counts[category]"></installation-category>
</div>
`,
  styles: [
    `.selected { background-color: #CFD8DC !important; color: white; }`,
    `.installs { margin: 0 0 2em 0; list-style-type: none; padding: 0; min-width: 32em; width: 100%; }`,
    `.installs li { display: block; background-color: #EEE; margin: 0.2em 0; vertical-align: middle; }`,
    `.installs li:hover { color: #304D6B; background-color: #DDD; }`,
  ],
  providers: [HubService],
})
//  [style.background-color]="this.getColorFor(hub)"


export class InstallationsComponent implements OnInit {
  installations: Installation[];
  allInstallations: Installation[];
  current: Installation;
  errorMessage: any;
  matchingParams: Params;
  sortColumn: string;
  sortAscending: boolean;
  sortNumeric: boolean;
  counts: number[];
  expanded: boolean[];

  constructor(
    private hubService: HubService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    AppComponent.SetTitle('All Installations');
    this.getNewData();
    this.activatedRoute.params.subscribe((params: Params) => {
      this.matchingParams = params;
      this.matchRows();
    });
  }

  getNewData(): void {
    this.hubService.getInstallations(null).subscribe(
      hubs => this.gotNewData(hubs),
      error => this.errorMessage = <any>error,
    );
  }

  private gotNewData(newData: Installation[]): void {
    let category_counts: number[] = [];
    this.allInstallations = [];
    for (let installation of newData) {
      let status = installation.status;
      if (status !== 'JOB_COMPLETED' && !!installation.geopal_data['status']) {
        status = installation.geopal_data['status'];
        installation.status = status;
      }
      if (category_counts[status]) {
        category_counts[status]++;
      } else {
        category_counts[status] = 0;
      }
      this.allInstallations.push(installation);
    }
    if (this.expanded === []) {
      // We only do this after the first read
      for (let category of Object.keys(category_counts)) {
        this.expanded[category] = false;
      }
    }
    try {
      this.matchRows();
    } catch (e) {
      this.installations = this.allInstallations;
    }
    this.counts = category_counts;
  }

  private matchRows(): void {
    if (this.allInstallations && (this.matchingParams['version'] || this.matchingParams['hub_health'])) {
      try {
        let matches: Installation[] = [];
        for (let installation of this.allInstallations) {
          if ((this.matchingParams['version'] && this.matchingParams['version'] === installation.job_id)) {
            matches.push(installation);
          }
        }
        this.installations = matches;
        if (this.matchingParams['version']) {
          AppComponent.SetTitle('Hubs with version ' + this.matchingParams['version']);
        } else if (this.matchingParams['hub_health']) {
          AppComponent.SetTitle('Hubs with health ' + this.matchingParams['hub_health']);
        }
      } catch (e) {
        AppComponent.SetTitle('All Hubs');
        this.installations = this.allInstallations;
      }
    } else {
      AppComponent.SetTitle('All Hubs');
      this.installations = this.allInstallations;
    }
    if (!!this.sortColumn) {
      this.sortRows();
    }
  }

  categories(): string[] {
    try {
      return Object.keys(this.counts);
    } catch(e) {
      return [];
    }
  }

  onSortColumn(e: string) {
    let columnSort = e.split(':');
    this.sortBy(columnSort[0], columnSort[1] === 'true');
  }

  sortBy(column: string, numeric: boolean): void {
    if (this.sortColumn && this.sortColumn === column) {
      this.sortAscending = !this.sortAscending;
    } else {
      this.sortColumn = column;
      this.sortNumeric = numeric;
      this.sortAscending = true;
    }
    this.sortRows();
  }

  private sortRows(): void {
    let sortColumn = this.sortColumn;
    let sortNumeric = this.sortNumeric;
    let sortAscending = this.sortAscending;
    this.installations.sort(function(a, b) {
      let result = 0;
      try {
        let f1 = a[sortColumn];
        let f2 = b[sortColumn];
        if (sortNumeric) {
          result = f1 - f2;
        } else {
          result = (f1 < f2 ? -1 : (f1 > f2 ? 1 : 0));
        }
        if (!sortAscending) {
          result *= -1;
        }
      } catch (e) {
        console.log(e.message);
        console.log(`sortColumn: ${sortColumn}`);
        console.log(`a: ${JSON.stringify(a, null, 2)}`);
      }
      return result;
    });
  }

  gotoDetail(install: Installation): void {
    // this.router.navigate(['/stock/install', install.job_id]);
    console.log(JSON.stringify(install, null, 2));
    console.log('Status: ' + install.status);
  }

}

